import { FC } from 'react';
import { Entity } from '@backstage/catalog-model';
import { Box, makeStyles } from '@material-ui/core';
import { useTemplateIcon, WbInfoTooltip } from '@agilelab/plugin-wb-platform';

const useStyles = makeStyles(theme => ({
  avatar: {
    width: '32px',
    height: '32px',
    minWidth: '32px',
    minHeight: '32px',
    pointerEvents: 'none',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[200]}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

interface Props {
  entity: Entity;
}

export const ComponentIcon: FC<Props> = ({ entity }) => {
  const classes = useStyles();
  const title = entity.metadata.title || entity.metadata.name;
  const icon = useTemplateIcon(entity, 'small');

  return (
    <WbInfoTooltip
      title={title}
      icon={<Box className={classes.avatar}>{icon}</Box>}
    />
  );
};
